import { c as _c } from "react/compiler-runtime";
import { STATES } from '@onefootprint/core';
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, type PathValue, useFormContext } from 'react-hook-form';
import Select from '../../select';
import type { SelectProps } from '../../select/select.types';
import FormWrapper from '../internals/form-wrapper';
import type { FormInputProps } from './form-input';
export type UsStateSelectOption = {
  label: string;
  value: string;
};
export type FormUsStateProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  rules?: ControllerProps<TFieldValues>['rules'];
  onChange?: (value: string) => void;
  value?: string;
  defaultValue?: string;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'type' | 'autoComplete' | 'onChange' | 'placeholder' | 'defaultValue'> & Omit<SelectProps, 'options' | 'value' | 'onChange' | 'ref' | 'label' | 'hasError' | 'id' | 'size'>;
export default function FormUsState(t0) {
  const $ = _c(32);
  let addon;
  let ariaLabel;
  let baseId;
  let defaultValue;
  let hint;
  let label;
  let name;
  let onChange;
  let props;
  let rules;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      rules,
      name,
      label,
      hint,
      addon,
      errorPosition: t1,
      orientation: t2,
      size: t3,
      id: baseId,
      onChange,
      defaultValue,
      "aria-label": ariaLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = addon;
    $[2] = ariaLabel;
    $[3] = baseId;
    $[4] = defaultValue;
    $[5] = hint;
    $[6] = label;
    $[7] = name;
    $[8] = onChange;
    $[9] = props;
    $[10] = rules;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    addon = $[1];
    ariaLabel = $[2];
    baseId = $[3];
    defaultValue = $[4];
    hint = $[5];
    label = $[6];
    name = $[7];
    onChange = $[8];
    props = $[9];
    rules = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
  }
  const errorPosition = t1 === undefined ? "relative" : t1;
  const orientation = t2 === undefined ? "vertical" : t2;
  const size = t3 === undefined ? "default" : t3;
  const {
    control
  } = useFormContext();
  const contextId = useId();
  const id = baseId || contextId;
  const t4 = defaultValue as PathValue<TFieldValues, Path<TFieldValues>>;
  let t5;
  if ($[14] !== addon || $[15] !== ariaLabel || $[16] !== defaultValue || $[17] !== errorPosition || $[18] !== hint || $[19] !== id || $[20] !== label || $[21] !== onChange || $[22] !== orientation || $[23] !== props || $[24] !== size) {
    t5 = t6 => {
      const {
        field,
        fieldState
      } = t6;
      const error = fieldState.error?.message;
      return <FormWrapper id={id} error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} addon={addon} orientation={orientation} fullWidth={true} disabled={props.disabled || field.disabled}><Select {...props} {...field} aria-label={label ? null : ariaLabel} disabled={field.disabled || props.disabled} options={STATES} value={(props.value || field.value || defaultValue) as string} onChange={value => {
          field.onChange(value as PathValue<TFieldValues, Path<TFieldValues>>);
          onChange?.(value as string);
        }} onBlur={() => {
          field.onBlur();
          props.onBlur?.();
        }} hasError={!!error} id={id} size={size} data-dd-privacy="mask" /></FormWrapper>;
    };
    $[14] = addon;
    $[15] = ariaLabel;
    $[16] = defaultValue;
    $[17] = errorPosition;
    $[18] = hint;
    $[19] = id;
    $[20] = label;
    $[21] = onChange;
    $[22] = orientation;
    $[23] = props;
    $[24] = size;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== control || $[27] !== name || $[28] !== rules || $[29] !== t4 || $[30] !== t5) {
    t6 = <Controller control={control} name={name} rules={rules} defaultValue={t4} render={t5} />;
    $[26] = control;
    $[27] = name;
    $[28] = rules;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}